import React from "react"
import { Typography } from "@material-ui/core"
import { useTranslation } from "react-i18next"
import useStyles from "../styles"
import { Link } from "@mui/material"

interface Props {}

const AuthError: React.FC<Props> = props => {
  const { t } = useTranslation()

  const classes = useStyles()

  return (
    <React.Fragment>
      <Typography variant="body1" className={classes.loginError} style={{ textAlign: "center" }}>
        {"Kimlik bilgileriniz kayıtlarımızla eşleşmedi."}{" "}
        <Link style={{ color: "#fff" }} href="/forgetpassword">
          {"Parolanızı mı unuttunuz? Sıfırlamak için burayı tıklayın."}
        </Link>
      </Typography>
    </React.Fragment>
  )
}

export default AuthError
